import React, { ReactNode } from 'react';

import { Box, PaperProps, Typography } from '@mui/material';
import MediaTypography from 'components/MediaTypography';

import {
	StyledProgramInfoBlockCounter,
	StyledProgramInfoBlockHeader,
	StyledProgramInfoBlockWrap,
} from './styled';

interface PropsType extends PaperProps {
	title?: string;
	counter?: number;
	children: ReactNode;
}

function ProgramInfoBlock({ title, children, counter, ...props }: PropsType) {
	return (
		<StyledProgramInfoBlockWrap elevation={2} {...props}>
			{title && (
				<StyledProgramInfoBlockHeader>
					<MediaTypography variant="subtitle1" variants={{ sm: 'subtitle2' }}>
						{title}
					</MediaTypography>
					{!!counter && (
						<StyledProgramInfoBlockCounter>
							<Typography variant="caption2">{counter}</Typography>
						</StyledProgramInfoBlockCounter>
					)}
				</StyledProgramInfoBlockHeader>
			)}
			<Box>{children}</Box>
		</StyledProgramInfoBlockWrap>
	);
}

export default ProgramInfoBlock;
